'use es6';

import { ActionTypes } from '../constants/AppConstants';
var defaultState = {
  desktop: {
    url: '',
    error: false
  },
  mobile: {
    url: '',
    error: false
  }
};

var Preview = function Preview() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.FETCH_PREVIEW_STARTED:
      return defaultState;

    case ActionTypes.DESKTOP_WEBSITE_PREVIEWED:
      return Object.assign({}, state, {
        desktop: {
          url: action.payload.url
        }
      });

    case ActionTypes.DESKTOP_WEBSITE_PREVIEWED_ERROR:
      return Object.assign({}, state, {
        desktop: {
          error: true
        }
      });

    case ActionTypes.MOBILE_WEBSITE_PREVIEWED:
      return Object.assign({}, state, {
        mobile: {
          url: action.payload.url
        }
      });

    case ActionTypes.MOBILE_WEBSITE_PREVIEWED_ERROR:
      return Object.assign({}, state, {
        mobile: {
          error: true
        }
      });

    default:
      return state;
  }
};

export default Preview;